import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  sv: { translation: sv },
  no: { translation: no },
  pt: { translation: pt },
  fr: { translation: fr }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en', // Always start with English
    debug: false,
    
    detection: {
      order: ['localStorage'], // Only use localStorage after user manually changes language
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;